



























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { availableDashboardViews, availableGenders, availableRoles, CredentialsType } from '@/api/types'
import moment from 'moment'
import { DashboardAPI, UserAPI } from '@/api/backend-client'
import { Dashboard } from '@/api/model/dashboard'
import KvButton from '@/components/input/KvButton.vue'
import { resizedToSizeAttachmentUrl } from '@/helpers/resize'

@Component({
    components: { KvButton },
})
export default class EditUserForm extends Vue {
    @Prop({ required: true }) readonly value!: User
    savingAvatar: boolean = false
    loading: boolean = false
    birthdate: string = null
    showRelations: boolean = false
    showRealworksAccountManagerId: boolean = false
    dashboards: Dashboard[] = []

    mounted() {
        if (this.value.birthdate) {
            this.birthdate = moment(this.value.birthdate).format('DD-MM-YYYY')
        }

        if (this.$currentCompany.hasCredentialsWithType(CredentialsType.REALWORKS)) {
            this.showRelations = true
            this.showRealworksAccountManagerId = true
        }

        this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.dashboards = await DashboardAPI.getAll()
        this.loading = false
    }

    @Watch('birthdate')
    onBirthdayChanged(): void {
        this.value.birthdate = moment(this.birthdate, 'DD-MM-YYYY').toISOString()
    }

    get roleOptions() {
        return availableRoles().map(value => ({
            label: this.$t(`role.${value}`),
            value,
        }))
    }

    get genderOptions() {
        return availableGenders().map(value => ({
            label: this.$t(`gender.${value}`),
            value,
        }))
    }

    get defaultDashboardViewOptions() {
        return availableDashboardViews().map(value => ({
            label: this.$t(`dashboard-view.${value}`),
            subtext: this.$t(`dashboard-view.${value}_subtext`),
            value,
        }))
    }

    get availableBranches() {
        return this.$currentCompany.getAvailableBranches()
    }

    get emailAlreadyInUse(): boolean {
        return this.$currentCompany.users.some((user: User) => user.email === this.value.email && user.id !== this.value.id)
    }

    get dashboardPermissionOptions(): Array<{ label: string, value: boolean|null }> {
        return [
            { label: 'Rol gebaseerd', value: null },
            { label: 'Altijd zichtbaar', value: true },
            { label: 'Altijd verborgen', value: false },
        ]
    }

    get dashboardPowerBiCustomRoleOptions(): Array<{ label: string, value: string }> {
        return this.$currentCompany.powerBiCustomRoles.map(powerBiCustomRole => {
            return {
                label: powerBiCustomRole,
                value: powerBiCustomRole,
            }
        })
    }

    getDashboardPermission(dashboardId): { dashboard: string, permission: boolean|null, powerBiCustomRole: string|null } {
        let dashboardPermission = this.value.dashboardPermissions.find(v => v.dashboard === dashboardId)
        if (!dashboardPermission) {
            dashboardPermission = {
                dashboard: dashboardId,
                permission: null,
                powerBiCustomRole: null,
            }

            this.value.dashboardPermissions.push(dashboardPermission)
        }

        return dashboardPermission
    }

    async updateAvatar(event: any): Promise<void> {
        try {
            this.savingAvatar = true
            const updatedUser = await UserAPI.updateAvatar(
                this.value.id,
                event.target.files[0],
            )

            this.value.avatar = null
            this.value.avatarUrl = updatedUser.avatarUrl
        } finally {
            this.savingAvatar = false
        }
    }

    get avatarPreview(): string {
        if (this.value.avatar) {
            return URL.createObjectURL(this.value.avatar)
        }

        if (this.value.avatarUrl) {
            return resizedToSizeAttachmentUrl(this.value.avatarUrl, 20)
        }

        return null
    }
}
